import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const expectedApi = environment.config.system.evePortalApiUrl;
    if (!request.url.includes(expectedApi)) {
      console.warn(
        '⚠️ Request going to unexpected URL:',
        request.url,
        'Expected:',
        expectedApi
      );
    }

    // Apply logic only for GraphQL requests.
    if (
      request.url.includes(environment.config.system.evePortalApiUrl) ||
      request.url.includes(environment.config.system.presenceVoiceUrl)
    ) {
      // Check if the request is a login mutation.
      // This is a simple regex check to see if the request body contains a login mutation.
      if (
        request.body &&
        request.body.query &&
        /mutation\s+login/i.test(request.body.query)
      ) {
        return next.handle(request);
      }

      const token = this.tokenService.getEveportalJwtToken();
      if (this.tokenService.isEveportalJwtTokenValid()) {
        // If token exists and is valid, clone the request with the token header.
        request = request.clone({
          setHeaders: {
            'eveportal-jwt': token!,
          },
        });
        return next.handle(request);
      } else {
        // Token is missing or expired, so try to renew it.
        const refreshToken = this.tokenService.getRefreshToken();
        // Call performAuthenticatedFlow to renew the token.
        return this.authService.performAuthenticatedFlow(refreshToken!).pipe(
          switchMap((result: any) => {
            // Assume result.jwt contains the new token.
            this.tokenService.setLoginRefreshToken(result);
            
            if(result.jwt == null || result.jwt == undefined){
              this.router.navigate(['/login']);
            }

            // Clone the request with the new token.
            const clonedRequest = request.clone({
              setHeaders: {
                'eveportal-jwt': result.jwt,
              },
            });
            return next.handle(clonedRequest);
          }),
          catchError((err: any) => {
            // On error, navigate to login.
            console.error('Token renewal failed:', err);
            this.router.navigate(['/login']);
            return throwError(err);
          })
        );
      }
    } else {
      // For non-GraphQL requests, continue without modification.
      return next.handle(request);
    }
  }
}
